export const AMRN = "AMRN";
export const EID = "EID";
export const EPI = "EPI";
export const EXTERNAL = "EXTERNAL";
export const INTERNAL = "INTERNAL";
export const MYCHARTLOGIN = "MYCHARTLOGIN";
export const WPRINTERNAL = "WPRINTERNAL";


